"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TEAM_NAME = exports.PACKAGE_NAME = exports.LIBRARY_NAME = exports.EMOTION_CACHE_KEY = void 0;
/* istanbul ignore file @preserve */ //
// DO NOT EDIT!
// This file was autogenerated by Eddie.
// Changes may cause incorrect behavior and will be lost when the file is regenerated.
//
// Run `npx eddie update workspace` to regenerate.
//
var LIBRARY_NAME = exports.LIBRARY_NAME = 'auth';
var PACKAGE_NAME = exports.PACKAGE_NAME = '@ori/auth';
var TEAM_NAME = exports.TEAM_NAME = 'Frontend Platform';
var EMOTION_CACHE_KEY = exports.EMOTION_CACHE_KEY = "".concat(LIBRARY_NAME, "-emotion-cache-key"); //# sourceMappingURL=constants-generated.js.map
